var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClient1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 32,
    viewBox: "0 0 128 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.043 9.32825H60.4735V12.9949H54.8207V30.7171H50.6957V12.9949H45.043V9.32825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.862 17.5782H74.2842C75.2823 17.5782 75.9749 17.3644 76.362 16.9366C76.7694 16.4888 76.9731 15.9486 76.9731 15.3171C76.9731 14.6656 76.7694 14.1156 76.362 13.6671C75.9542 13.2193 75.262 12.9949 74.2842 12.9949H70.862V17.5782ZM72.3592 21.2449H70.862V30.7171H66.7373V9.32825H74.529C76.4845 9.32825 78.0425 9.85822 79.2036 10.9171C80.4666 12.1193 81.0981 13.5755 81.0981 15.2866C81.0981 16.9977 80.4666 18.4545 79.2036 19.656C78.5929 20.2267 77.8796 20.6443 77.0651 20.9091L85.0706 30.7171H79.9675L72.3592 21.2449Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.646 3.74999L101.412 9.08144C100.853 8.99808 100.282 8.95488 99.7 8.95488C93.3488 8.95488 88.2 14.1036 88.2 20.4549C88.2 26.8062 93.3488 31.9549 99.7 31.9549C103.042 31.9549 106.051 30.5292 108.152 28.2528L120.945 20.866C121.184 20.728 121.266 20.4222 121.128 20.183C120.99 19.9439 120.684 19.8619 120.445 20L109.642 26.2378C110.633 24.5389 111.2 22.5631 111.2 20.4549C111.2 15.2018 107.678 10.7713 102.866 9.39626L111.146 4.61602C111.385 4.47794 111.467 4.17215 111.329 3.933C111.191 3.69386 110.885 3.61192 110.646 3.74999ZM99.7 11.9549C104.394 11.9549 108.2 15.7605 108.2 20.4549C108.2 25.1493 104.394 28.9549 99.7 28.9549C95.0056 28.9549 91.2 25.1493 91.2 20.4549C91.2 15.7605 95.0056 11.9549 99.7 11.9549Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.255 12.75L122.647 6.75C122.886 6.61193 123.192 6.69387 123.33 6.93301C123.468 7.17216 123.386 7.47795 123.147 7.61602L112.755 13.616C112.516 13.7541 112.21 13.6722 112.072 13.433C111.934 13.1939 112.016 12.8881 112.255 12.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.255 17.75L126.245 10.25C126.484 10.1119 126.79 10.1939 126.928 10.433C127.066 10.6722 126.984 10.978 126.745 11.116L113.755 18.616C113.515 18.7541 113.21 18.6722 113.072 18.433C112.934 18.1939 113.015 17.8881 113.255 17.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7271 17.25L124.172 0.25C124.411 0.111929 124.717 0.193866 124.855 0.433012C124.993 0.672159 124.911 0.977954 124.672 1.11602L95.2271 18.116C94.988 18.2541 94.6822 18.1722 94.5441 17.933C94.406 17.6939 94.488 17.3881 94.7271 17.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 9,
    width: 16,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9463 9.02246H40.9185V31.0228H25.9463V9.02246Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9463 27.8145L28.6352 25.0034C30.0608 26.5722 31.7413 27.3558 33.6768 27.3558C34.5935 27.3558 35.3421 27.1015 35.9227 26.5919C36.5032 26.083 36.7935 25.4417 36.7935 24.6669C36.7935 23.8528 36.4676 23.1958 35.8157 22.6964C35.1635 22.1974 34.1705 21.6935 32.8366 21.1839C31.5023 20.675 30.5398 20.2472 29.9491 19.9003C27.9324 18.7195 26.9241 17.0997 26.9241 15.0423C26.9241 13.2293 27.6268 11.7728 29.0324 10.6728C30.438 9.5728 32.088 9.02246 33.9824 9.02246C36.3046 9.02246 38.3719 9.69503 40.1852 11.0395L38.0463 14.095C37.0274 13.1583 35.7954 12.6895 34.3491 12.6895C33.4728 12.6895 32.7038 12.8833 32.0421 13.27C31.3797 13.6571 31.0491 14.238 31.0491 15.0117C31.0491 15.6228 31.3899 16.1575 32.0727 16.6159C32.7551 17.0742 33.5747 17.4816 34.5324 17.8381C35.4898 18.1946 36.4523 18.6071 37.4199 19.0756C38.3872 19.5445 39.2122 20.2472 39.8949 21.1839C40.5773 22.121 40.9185 23.2617 40.9185 24.6062C40.9185 26.4602 40.2052 27.9927 38.7796 29.2048C37.3537 30.4168 35.6524 31.0228 33.6768 31.0228C30.8657 31.0228 28.2885 29.9534 25.9463 27.8145Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 22,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.21524H21.236V30.6293H0V9.21524Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 9.21524L0 30.6041C0 30.6041 4.13824 30.6608 4.30833 30.6041C4.47843 30.5474 10.6028 15.8764 10.6028 15.8764L16.9278 30.6041H21.2361L12.0694 9.21524H9.16667Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient1);
export default __webpack_public_path__ + "static/media/client_1.71fa65c36d8b9a119fbb6374b4296350.svg";
export { ForwardRef as ReactComponent };